<template>
  <div>
    <div class="text-center">
      {{
        activeBuilding?.address?.street +
        ' ' +
        activeBuilding?.address?.houseNumber
      }}
    </div>

    <BaseSection heading="GW Installationsorte auswählen (Mehrauswahl möglich)">
      <InstallationLocationsTable
        v-model:installation-locations="installationLocations"
        @update-location="handleUpdateLocation"
      />
    </BaseSection>

    <BaseSection
      heading="Artikelliste für den Montagetermin (ggf. Korrektur notwendig)"
    >
      <template #header>
        <HelpTooltip
          class="flex self-end"
          position="left"
          :message="helpTexts.productEstimations"
        />
      </template>

      <EstimatedAdaptersTable :inspected-building="inspectedBuilding" />
    </BaseSection>
    <BaseSection heading="Fotos">
      <ImageCapture
        ref="imageCaptureRef"
        :object-id="inspectedBuilding.id"
        :object-type="ImageObjectType.INSPECTED_BUILDING"
        :capture-image-information="true"
      />
    </BaseSection>
  </div>
</template>
<script setup lang="ts">
import { computed, onBeforeMount, ref, Ref } from 'vue';
import { ImageObjectType } from '@/models/Image';
import ImageCapture, {
  ImageCaptureRef,
} from '@/components/Forms/DeviceFormComponents/ImageCapture.vue';
import BaseSection from '@/components/UI/Card/BaseSection.vue';
import { InspectedBuilding } from '@/models/InspectedBuilding';
import { useBuildingStore } from '@/store/entities/buildingStore';
import { useInspectedBuildingForm } from '@/composables/useInspectedBuildingForm';
import EstimatedAdaptersTable from '@/components/Forms/EstimatedAdaptersTable.vue';
import helpTexts from '@/utils/i18n/helpTexts.json';
import HelpTooltip from '@/components/UI/Hint/HelpTooltip.vue';
import InstallationLocationsTable from '@/components/InstallationLocation/InstallationLocationsTable.vue';
import { InspectionPointsLocation } from '@/composables/useInstallationLocationsTable';

const props = defineProps<{
  node?: InspectedBuilding;
}>();

const emit = defineEmits(['update-entity']);

const imageCaptureRef: Ref<ImageCaptureRef | null> = ref(null);

const activeBuilding = computed(() => {
  return useBuildingStore().getCurrentBuilding();
});

const {
  inspectedBuilding,
  installationLocations,
  initializeInspectedBuildingForm,
  handleSubmit,
  onUpdateLocation,
} = useInspectedBuildingForm(
  props.node,
  activeBuilding.value?.id,
  imageCaptureRef,
  emit
);

const handleUpdateLocation = (
  index: number,
  updatedLocation: InspectionPointsLocation
) => {
  installationLocations.value = onUpdateLocation(index, updatedLocation);
};

onBeforeMount(() => {
  initializeInspectedBuildingForm();
});

defineExpose({
  isFormValid: true,
  handleSubmit,
});
</script>
